import CircularProgress from '@mui/material/CircularProgress';

import './styles.css'

const Button = ({
    label,
    onClick,
    disabled,
    style,
    kind,
    loading
}) => {
    return (
        <button
            style={style}
            disabled={disabled || loading}
            className={`upa-button ${kind ? kind : "" } ${disabled ? "disabled" : ""} ${loading ? "disabled" : ""} `}
            onClick={onClick}
        >   
            <div className='upa-button-label'>
                {label}
                {loading && <CircularProgress size={12} sx={{color: kind === "primary" ? "white" : "var(--upa-dark)", marginLeft: 1}}/>}
            </div>
        </button>
    )
}

export default Button;